import { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { ventesData } from '../data/ventesData';
import { Target } from 'lucide-react';
import AikupCard from '../components/AikupCard';
import AikupModal from '../components/AikupModal';
import GestionPlaintesModal from '../components/GestionPlaintesModal';
import ExpertVisionModal from '../components/ExpertVisionModal';
import CadreReferentielModal from '../components/CadreReferentielModal';
import AméliorationContinueModal from '../components/AméliorationContinueModal';
import MethodologiePRIsMEModal from '../components/MethodologiePRIsMEModal';
import PlanMarketingModal from '../components/PlanMarketingModal';
import BZTelecomModal from '../components/BZTelecomModal';
import GenerateurPropositionModal from '../components/GenerateurPropositionModal';
import GuideVentePRIsMEModal from '../components/GuideVentePRIsMEModal';
import GuideCreationODSModal from '../components/GuideCreationODSModal';
import ODSKnowledgeTileModal, { type ODSKnowledgeTileId } from '../components/ODSKnowledgeTileModal';
import DirecteurCompteReferentielModal from '../components/DirecteurCompteReferentielModal';
import ReferentielDirecteurCompteModal from '../components/ReferentielDirecteurCompteModal';
import AritziaStrategieMarketingModal from '../components/AritziaStrategieMarketingModal';
import GouvernanceContratsBZModal from '../components/GouvernanceContratsBZModal';
import ComiteTIPrismeModal from '../components/ComiteTIPrismeModal';
import ProcedureGestionProjetsModal from '../components/ProcedureGestionProjetsModal';
import ResponsabiliteVentesBZTelecomModal from '../components/ResponsabiliteVentesBZTelecomModal';
import SuiviClientsIAModal from '../components/SuiviClientsIAModal';
import EbaucheCadreBZModal from '../components/EbaucheCadreBZModal';
import AIInsightBubble from '../components/AIInsightBubble';
import Header from '../layout/Header';
import LeadersSection from '../components/LeadersSection';
import FormationGestionDocumentaireCard from '../components/FormationGestionDocumentaireCard';
import ArbrePRIsMECard from '../components/ArbrePRIsMECard';
import type { VentesItem } from '../data/ventesData';
import { useAuth } from '../contexts/AuthContext';

export default function DirecteurCompte() {
  const { user } = useAuth();
  const isVentesReunionOnlyUser = useMemo(() => {
    const email = user?.email?.toLowerCase();
    return (
      email === 'jessica.pratt@bzinc.ca' ||
      email === 'rosalie.emond@bzinc.ca' ||
      email === 'melissa.morency@bzinc.ca' ||
      email === 'edita.puhovac@bzinc.ca' ||
      email === 'tim.gaudet@bzinc.ca' ||
      email === 'michael.roy@bzinc.ca' ||
      email === 'zachary.seguin@bzinc.ca'
    );
  }, [user?.email]);

  const [selectedItem, setSelectedItem] = useState<VentesItem | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expertVisionModal, setExpertVisionModal] = useState<{
    isOpen: boolean;
    expert: 'dany' | 'yannick' | 'francois' | null;
    item: VentesItem | null;
  }>({
    isOpen: false,
    expert: null,
    item: null,
  });
  const [isCadreReferentielOpen, setIsCadreReferentielOpen] = useState(false);
  const [isAméliorationOpen, setIsAméliorationOpen] = useState(false);
  const [isMethodologieOpen, setIsMethodologieOpen] = useState(false);
  const [isPlanMarketingOpen, setIsPlanMarketingOpen] = useState(false);
  const [isBZTelecomOpen, setIsBZTelecomOpen] = useState(false);
  const [isGenerateurPropositionOpen, setIsGenerateurPropositionOpen] = useState(false);
  const [isGuideVentePRIsMEOpen, setIsGuideVentePRIsMEOpen] = useState(false);
  const [isDirecteurCompteReferentielOpen, setIsDirecteurCompteReferentielOpen] = useState(false);
  const [isDirecteurCompteReferentielSimpleOpen, setIsDirecteurCompteReferentielSimpleOpen] = useState(false);
  const [isAritziaStrategieMarketingOpen, setIsAritziaStrategieMarketingOpen] = useState(false);
  const [isGouvernanceContratsOpen, setIsGouvernanceContratsOpen] = useState(false);
  const [isReunionDirectionOpen, setIsReunionDirectionOpen] = useState(false);
  const [isProcedureGestionProjetsOpen, setIsProcedureGestionProjetsOpen] = useState(false);
  const [isGestionPlaintesOpen, setIsGestionPlaintesOpen] = useState(false);
  const [isResponsabiliteVentesBZTelecomOpen, setIsResponsabiliteVentesBZTelecomOpen] = useState(false);
  const [isSuiviClientsIAOpen, setIsSuiviClientsIAOpen] = useState(false);
  const [isEbaucheCadreBZOpen, setIsEbaucheCadreBZOpen] = useState(false);
  const [isGuideCreationODSOpen, setIsGuideCreationODSOpen] = useState(false);
  const [selectedODSTile, setSelectedODSTile] = useState<ODSKnowledgeTileId | null>(null);

  const handleCardClick = (item: VentesItem) => {
    if (item.id === 1) {
      // Si c'est la carte "Référentiel Directeur de Compte"
      setIsDirecteurCompteReferentielOpen(true);
    } else if (item.id === 27) {
      // Nouvelle tuile: Référentielle directeur de compte
      setIsDirecteurCompteReferentielSimpleOpen(true);
    } else if (item.id === 6) {
      // Si c'est la carte "Cadre Référentiel BZ"
      setIsCadreReferentielOpen(true);
    } else if (item.id === 10) {
      // Si c'est la carte "Amélioration Continue et Rigueur"
      setIsAméliorationOpen(true);
    } else if (item.id === 13) {
      // Si c'est la carte "Méthodologie PRIsME"
      setIsMethodologieOpen(true);
    } else if (item.id === 17) {
      // Si c'est la carte "Plan Marketing & Stratégie 2025"
      setIsPlanMarketingOpen(true);
    } else if (item.id === 19) {
      // Si c'est la carte "BZ Telecom - Partenariat Stratégique"
      setIsBZTelecomOpen(true);
    } else if (item.id === 22) {
      // Si c'est la carte "Générateur de Propositions Commerciales"
      setIsGenerateurPropositionOpen(true);
    } else if (item.id === 24) {
      // Si c'est la carte "Guide de Vente PRIsME"
      setIsGuideVentePRIsMEOpen(true);
    } else if (item.id === 25) {
      // Si c'est la carte "Stratégie marketing site web - Exemple Aritzia"
      setIsAritziaStrategieMarketingOpen(true);
    } else if (item.id === 26) {
      // Réunion département des ventes (accès à tous les utilisateurs Ventes & Marketing)
      setIsReunionDirectionOpen(true);
    } else if (item.id === 28) {
      // Procédure de gestion de projet (base de gestion de projet) — liste de taches (représentation statique)
      setIsProcedureGestionProjetsOpen(true);
    } else if (item.id === 29) {
      // Gestion de plaintes — contenu markdown dédié
      setIsGestionPlaintesOpen(true);
    } else if (item.id === 30) {
      // Responsabilités ventes BZ Telecom
      setIsResponsabiliteVentesBZTelecomOpen(true);
    } else if (item.id === 31) {
      // Miroir de la card Solutions d'affaires / Suivi clients IA
      setIsSuiviClientsIAOpen(true);
    } else if (item.id === 32) {
      // Miroir de la card du Comité PRIsME
      setIsEbaucheCadreBZOpen(true);
    } else if (item.id === 33) {
      // Guide de création d’ODS inspiré de Boréale V6 et du cadre client BZ
      setIsGuideCreationODSOpen(true);
    } else if (item.id === 34) {
      // Section ODS BZ — Instructions communes pour les bots
      setSelectedODSTile('bots');
    } else if (item.id === 35) {
      // Section ODS BZ — Principes d’une bonne ODS
      setSelectedODSTile('principes');
    } else if (item.id === 36) {
      // Section ODS BZ — Structure standard d’une ODS
      setSelectedODSTile('structure');
    } else if (item.id === 37) {
      // Section ODS BZ — Règle des trois choix
      setSelectedODSTile('trois-choix');
    } else if (item.id === 38) {
      // Section ODS BZ — Qualification du contexte client
      setSelectedODSTile('qualification-contexte');
    } else if (item.id === 39) {
      // Section ODS BZ — Inclusions, exclusions et limites
      setSelectedODSTile('inclusions-limites');
    } else if (item.id === 40) {
      // Section ODS BZ — Piliers BZ et facteurs décisionnels
      setSelectedODSTile('piliers-facteurs');
    } else if (item.id === 41) {
      // Section ODS BZ — Tarification et investissement
      setSelectedODSTile('tarification-investissement');
    } else if (item.id === 42) {
      // Section ODS BZ — Personnalisation client de chaque ODS
      setSelectedODSTile('personnalisation-client');
    } else if (item.id === 43) {
      // Section ODS BZ — Termes et conditions
      setSelectedODSTile('termes-conditions');
    } else if (item.id === 44) {
      // Section ODS BZ — Convention de service 2026
      setSelectedODSTile('convention-service');
    } else {
      setSelectedItem(item);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedItem(null), 300);
  };

  const leaders = [
    {
      name: "Antoine Giroux",
      title: "Directeur des ventes",
      avatar: "/AG-transparent.png",
      vision: "Antoine est un naturel et grounder sur les résultats. Il sait mobiliser et motiver son équipe à atteindre des niveaux de rendement et d'excellence à la hauteur de BZ et des clients. Il voit PRIsME comme l'outil qui structure notre approche commerciale et garantit la qualité de nos livrables.",
      attentes: "Antoine s'attend à ce que PRIsME facilite la vente en montrant notre excellence structurée. Il veut voir chaque membre de l'équipe utiliser PRIsME pour présenter notre valeur de manière cohérente et professionnelle. Son objectif : que PRIsME soit notre différenciateur commercial.",
      pagePRIsME: "La page PRIsME de Ventes & Marketing reflète notre excellence commerciale : référentiel directeur de compte, plan marketing, générateur de propositions, méthodologie. C'est notre vitrine commerciale."
    },
    {
      name: "Rosalie Emond",
      title: "Responsable marketing",
      avatar: "/RE.png",
      vision: "Rosalie est une communicatrice née et d'un naturel en public comme on peut voir rarement. Son niveau d'énergie et son don de raconteuse emmènent toujours des discussions agréables et aident à casser la glace. Les événements clients sont gérés de main de maître. Elle voit PRIsME comme l'outil qui structure notre communication et notre présence événementielle.",
      attentes: "Rosalie s'attend à ce que PRIsME renforce notre présence événementielle et notre communication. Elle veut voir PRIsME utilisé dans chaque événement client pour créer de l'engagement et de l'enthousiasme. Son objectif : que PRIsME soit l'outil qui transforme nos événements en expériences mémorables.",
      pagePRIsME: "La page PRIsME de Ventes & Marketing représente pour Rosalie l'opportunité de montrer notre excellence en communication et événementiel. C'est l'outil qui structure notre présence et notre impact."
    }
  ];

  // Leaders pour les cards (avatars affichés sur chaque card)
  const cardLeaders = [
    { name: "Antoine Giroux", title: "Directeur des ventes", avatar: "/AG-transparent.png" },
    { name: "Rosalie Emond", title: "Responsable marketing", avatar: "/RE.png" },
  ];

  // Organiser par catégorie
  const visibleVentesData = useMemo(() => {
    // Masquer la tuile "Référentiel Directeur de Compte - Standards d'Excellence" (id: 1)
    const base = ventesData.filter((i) => i.id !== 1);
    if (!isVentesReunionOnlyUser) return base;
    // Accès restreint: garder la tuile "Réunion département des ventes" + quelques tuiles essentielles
    // (Guide de vente, Méthodologie, Cadre référentiel) pour ces usagers.
    const allowedIds = new Set([6, 13, 24, 26, 27, 28, 30, 31, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44]);
    return base.filter((i) => allowedIds.has(i.id));
  }, [isVentesReunionOnlyUser]);

  const categories = Array.from(new Set(visibleVentesData.map(item => item.category)));

  return (
    <div className="flex-1 w-full max-w-none min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Header
        title="Ventes & Marketing"
        subtitle="Les piliers du développement commercial & excellence en vente pour une croissance durable"
      />

      <div className="w-full max-w-none px-6 py-6 xl:px-8 2xl:px-10">
        {!isVentesReunionOnlyUser && (
          <div className="w-full max-w-none mb-12">
            <LeadersSection leaders={leaders} title="Nos Leaders - Ventes & Marketing" />
          </div>
        )}

        {/* Cards par catégorie — même structure visuelle que Solutions d'affaires */}
        <div className="w-full max-w-none space-y-8 mb-12">
          {categories.map((category, categoryIndex) => {
            const itemsInCategory = visibleVentesData.filter(item => item.category === category);

            return (
              <motion.div
                key={category}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: categoryIndex * 0.05 }}
                className="w-full max-w-none bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden"
              >
                <div className="px-6 py-5 bg-gradient-to-r from-blue-900 via-sky-800 to-cyan-700 text-white">
                  <h3 className="text-xl md:text-2xl font-bold">{category}</h3>
                </div>

                <div className="px-6 py-6 bg-gray-50/80">
                  <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                    {itemsInCategory.map((item, idx) => (
                      <motion.div
                        key={item.id}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: categoryIndex * 0.05 + 0.08 + idx * 0.03 }}
                        className="w-full max-w-none"
                      >
                        <AikupCard
                          item={item}
                          onClick={() => handleCardClick(item)}
                          onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                            setExpertVisionModal({
                              isOpen: true,
                              expert,
                              item,
                            });
                          }}
                          index={idx}
                          customLeaders={cardLeaders}
                          onLeaderClick={(leader) => {
                            const selectedLeader = leaders.find(l => l.name === leader.name);
                            if (selectedLeader) {
                              console.log('Leader clicked:', selectedLeader);
                            }
                          }}
                        />
                      </motion.div>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Cards Formation, Arbre PRIsME et Gouvernance contrats BZ */}
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-6 mb-12 md:grid-cols-2 xl:grid-cols-4">
          <FormationGestionDocumentaireCard
            department="Ventes & Marketing"
            domain="Ventes & Marketing"
            index={0}
          />
          <ArbrePRIsMECard index={1} />

          {/* Card Gouvernance – Gestion des contrats BZ (gardée hors accès restreint) */}
          {!isVentesReunionOnlyUser && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-xl shadow-lg p-8 border-2 border-amber-200 hover:border-amber-400 transition-all cursor-pointer"
              onClick={() => setIsGouvernanceContratsOpen(true)}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="bg-gradient-to-r from-amber-500 to-orange-600 p-3 rounded-xl">
                      <Target className="w-8 h-8 text-white" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900">
                        📜 Gouvernance – Gestion des contrats BZ
                      </h3>
                      <p className="text-sm text-gray-600 mt-1">
                        Cadre de gouvernance contrats BZ, aussi critique pour la performance ventes & marges.
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed mb-4">
                    Même card que dans Administration & RH, mais vue ici comme levier commercial&nbsp;:
                    alignement contrats ↔ offres, rentabilité client et réduction des orphelins.
                  </p>
                  <div className="flex flex-wrap items-center gap-3 text-xs text-gray-600">
                    <span className="px-3 py-1 rounded-full bg-amber-100 text-amber-800 font-semibold">
                      Ventes & Marketing
                    </span>
                    <span className="px-3 py-1 rounded-full bg-orange-100 text-orange-800">
                      Gouvernance contrats
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </div>

      <AikupModal
        item={selectedItem}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />

      <GestionPlaintesModal
        isOpen={isGestionPlaintesOpen}
        onClose={() => setIsGestionPlaintesOpen(false)}
      />

      <ResponsabiliteVentesBZTelecomModal
        isOpen={isResponsabiliteVentesBZTelecomOpen}
        onClose={() => setIsResponsabiliteVentesBZTelecomOpen(false)}
      />

      <SuiviClientsIAModal
        isOpen={isSuiviClientsIAOpen}
        onClose={() => setIsSuiviClientsIAOpen(false)}
      />

      <EbaucheCadreBZModal
        isOpen={isEbaucheCadreBZOpen}
        onClose={() => setIsEbaucheCadreBZOpen(false)}
      />

      <GuideCreationODSModal
        isOpen={isGuideCreationODSOpen}
        onClose={() => setIsGuideCreationODSOpen(false)}
      />

      <ODSKnowledgeTileModal
        tile={selectedODSTile}
        isOpen={selectedODSTile !== null}
        onClose={() => setSelectedODSTile(null)}
      />

      <CadreReferentielModal
        isOpen={isCadreReferentielOpen}
        onClose={() => setIsCadreReferentielOpen(false)}
      />

      <AméliorationContinueModal
        isOpen={isAméliorationOpen}
        onClose={() => setIsAméliorationOpen(false)}
      />

      <MethodologiePRIsMEModal
        isOpen={isMethodologieOpen}
        onClose={() => setIsMethodologieOpen(false)}
      />

      <PlanMarketingModal
        isOpen={isPlanMarketingOpen}
        onClose={() => setIsPlanMarketingOpen(false)}
      />

      <BZTelecomModal
        isOpen={isBZTelecomOpen}
        onClose={() => setIsBZTelecomOpen(false)}
      />

      <GenerateurPropositionModal
        isOpen={isGenerateurPropositionOpen}
        onClose={() => setIsGenerateurPropositionOpen(false)}
      />

      <GuideVentePRIsMEModal
        isOpen={isGuideVentePRIsMEOpen}
        onClose={() => setIsGuideVentePRIsMEOpen(false)}
      />
      
      <DirecteurCompteReferentielModal
        isOpen={isDirecteurCompteReferentielOpen}
        onClose={() => setIsDirecteurCompteReferentielOpen(false)}
      />

      <ReferentielDirecteurCompteModal
        isOpen={isDirecteurCompteReferentielSimpleOpen}
        onClose={() => setIsDirecteurCompteReferentielSimpleOpen(false)}
      />

      <AritziaStrategieMarketingModal
        isOpen={isAritziaStrategieMarketingOpen}
        onClose={() => setIsAritziaStrategieMarketingOpen(false)}
      />

      <GouvernanceContratsBZModal
        isOpen={isGouvernanceContratsOpen}
        onClose={() => setIsGouvernanceContratsOpen(false)}
      />

      <ComiteTIPrismeModal
        isOpen={isReunionDirectionOpen}
        onClose={() => setIsReunionDirectionOpen(false)}
        title="Réunion département des ventes"
        scope="REUNION_VENTES_MARKETING"
      />

      <ProcedureGestionProjetsModal
        isOpen={isProcedureGestionProjetsOpen}
        onClose={() => setIsProcedureGestionProjetsOpen(false)}
      />

      <ExpertVisionModal
        isOpen={expertVisionModal.isOpen}
        onClose={() => setExpertVisionModal({ isOpen: false, expert: null, item: null })}
        expert={expertVisionModal.expert}
        item={expertVisionModal.item}
      />

      <AIInsightBubble />
    </div>
  );
}
